var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img-outer"},[_c('img',{staticClass:"loader",attrs:{"src":require("../assets/image/loader.gif")}})])
}]

export { render, staticRenderFns }